import MenuComponent from '@/components/common/MenuComponent/MenuComponent.vue'
import FilterComponent from '@/components/common/FilterComponent/FilterComponent.vue'
import CallWidget from '@/features/CallWidget/CallWidget.vue'
import SubscriptionControl from '@/features/SubscriptionControl/SubscriptionControl.vue'
import { useAuthStore } from '@/store/auth/auth'
import { Breakpoints } from '@/enum/Breakpoints'
import { useUIStore } from '@/store/ui/ui'
import { useCompanyStore } from '@/store/company'
import { onClickOutside } from '@vueuse/core'
import { computed, defineComponent, onMounted, onUnmounted, onBeforeMount, ref } from 'vue'
import { useRoute, RouterLink } from 'vue-router'
import { useLogout } from '@/composables/useLogout'
import type { MaybeElementRef } from '@vueuse/core'
import type { MenuItem } from '@/types/lists'

export default defineComponent({
  name: 'MainLayout',
  components: {
    MenuComponent,
    FilterComponent,
    RouterLink,
    CallWidget,
    SubscriptionControl,
  },
  setup() {
    const UIStore = useUIStore()
    const route = useRoute()
    const authStore = useAuthStore()
    const companyStore = useCompanyStore()
    const { logout, adminLogout } = useLogout()

    const menuRef = ref<(MaybeElementRef & { isConfirmPopupOpen?: boolean }) | null>(null)
    const isAdmin = computed(() => authStore.isAdmin)
    const isAdminPages = computed(() => (route.path as string).includes('admin'))

    const userMenuItems: MenuItem[] = [
      {
        title: 'Личный кабинет',
        route: '/profile',
      },
      {
        title: 'Выйти',
        color: 'red',
        callback: 'logout',
      },
    ]
    const adminMenuItems: MenuItem[] = [
      {
        title: 'Выйти',
        color: 'red',
        callback: 'adminLogout',
      },
    ]
    const menuItems = computed(() => (isAdmin.value ? adminMenuItems : userMenuItems))
    const notebookBreakpoint = Breakpoints.NOTEBOOK

    const isFilter = computed(() => route.meta.withSearch)
    const toggleMenu = () => {
      UIStore.toggleMenu()
      localStorage.setItem('isMenuOpen', UIStore.getIsMenuOpen.toString())
    }

    const checkMenuVisibility = () => {
      if (window.innerWidth < notebookBreakpoint && UIStore.getIsMenuOpen) {
        toggleMenu()
      }
    }

    onClickOutside(menuRef, () => {
      const hasPopupOpen = (
        el: MaybeElementRef | null,
      ): el is MaybeElementRef & {
        isConfirmPopupOpen: boolean
        isCompanyMenuItemFormOpen: boolean
      } => {
        return (
          el != null
          && (('isConfirmPopupOpen' in el && (el.isConfirmPopupOpen as boolean))
            || ('isCompanyMenuItemFormOpen' in el && (el.isCompanyMenuItemFormOpen as boolean)))
        )
      }
      if (window.innerWidth < notebookBreakpoint && menuRef.value && !hasPopupOpen(menuRef.value)) {
        toggleMenu()
      }
    })

    onBeforeMount(async () => {
      if (isAdmin.value)
        return
      await companyStore.getMenuSections()
    })

    onMounted(() => {
      window.addEventListener('resize', checkMenuVisibility)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMenuVisibility)
    })

    return {
      UIStore,
      authStore,
      menuRef,
      menuItems,
      isAdmin,
      toggleMenu,
      isFilter,
      logout,
      adminLogout,
      isAdminPages,
    }
  },
})
